import { Button } from 'app/components/ui/button'
import { Input } from 'app/components/ui/input'

export type FlushComponentProps = {
  pattern: string
  onPatternChange: (pattern: string) => void
  flushing: boolean
  message: string
  onFlush: () => void
}

export function FlushComponent({
  pattern,
  onPatternChange,
  flushing,
  message,
  onFlush,
}: FlushComponentProps): React.ReactElement {
  return (
    <form
      className="flex max-w-md flex-col gap-3 p-4"
      onSubmit={(event) => {
        event.preventDefault()
        onFlush()
      }}
    >
      <label className="text-sm" htmlFor="cache-flush-pattern">
        Cache key prefix to flush
      </label>
      <Input
        id="cache-flush-pattern"
        value={pattern}
        placeholder="e.g. contact:"
        onChange={(event) => onPatternChange(event.target.value)}
      />
      <Button type="submit" disabled={flushing || !pattern.trim()}>
        {flushing ? `Flushing…` : `Flush cache`}
      </Button>
      {message && <div className="text-sm">{message}</div>}
    </form>
  )
}
